module.exports = __webpack_public_path__ + "static/img/v4.890822a.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/v4.png
// module id = rHuL
// module chunks = 1